/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IFiltrosReferencias from './entidades/filtrosReferencias';
import IReferencias from './entidades/referencias';

export default class ModeloReferencias {
    public consultarReferencias() {
        return manejadorRest<IRespuesta<IReferencias>>(() => negocio.get('Referencia/ConsultarListaReferencia'));
    }
    public crearReferencias(referencias: IReferencias) {
        return manejadorRest<IRespuesta<IReferencias>>(() => negocio.post('Referencia/GuardarReferencia', referencias));
    }
    public editarReferencias(referencias: IReferencias) {
        return manejadorRest<IRespuesta<IReferencias>>(() => negocio.put('Referencia/EditarReferencia', referencias));
    }
    public eliminarReferencias(referencias: IReferencias) {
        return manejadorRest<IRespuesta<IReferencias>>(() =>
            negocio.delete('Referencia/EliminarReferencia', referencias)
        );
    }
    public consultarListaReferenciasPorFiltro(filtrosReferencias: IFiltrosReferencias) {
        return manejadorRest<IRespuesta<IReferencias>>(
            () => negocio.post('Referencia/ConsultarListaReferenciaPorFiltro', filtrosReferencias),
            true
        );
    }
}
